import { useState } from 'react'
import axios from 'axios'
import { useCookies } from 'react-cookie'
import { api } from '../../common/api'
import { ACCESS_TOKEN } from '../../common/util' 

type Club = {
    content: ClubData[];
    number: number;
    totalElements: number;
}

export type ClubData = {
    academyId: number
    academyAddress: string
    academyName: string
    active: boolean
    appliedDate: string
    academyImageUrl: string
}

export default function useGetClubs() {
    const baseUrl = api.base_url
    const [cookies] = useCookies([ACCESS_TOKEN])
    const [clubSearchResults, setClubSearchResults] = useState<Club | null>()
    const [clubError, setClubError] = useState('')

    const getClubs = async (search: string, pageNum?: number, active?:string) => {
        const pageValue = pageNum ? (pageNum - 1) : 0;
        const activeValue = active === 'inactive' ? false : true;

        try {
            const response = await axios(`${baseUrl}/academy/admin-simple?active=${activeValue}&page=${pageValue}&size=8&searchValue=${search}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${cookies[ACCESS_TOKEN]}`
                }
            })
            setClubSearchResults(response.data.data)
        } catch (err) {
            console.error((err as Error).message)
            setClubError((err as Error).message)
        }
    }
    
    return { getClubs, clubError, clubSearchResults, setClubSearchResults }
}